export const isEmptyString = (value: string) => value === ''